import { DataTable } from '../../../../../../../components/UI/MDC/DataTable/DataTable';
import Section from '../../../../../components/NewApplication/Section';
import ComponentDependencyForm from './ComponentDependencyForm';
import { Button } from '@upmc/ims.component-library';
import { DeactivateComponentDependency } from '../../../../../_api';
import ComponentDependencyRequest from '../../../../../../../Classes/ResponseModels/ApplicationManagement/ComponentDependencyRequest';
import ApiErrors from '../../../../../components/NewApplication/ApiErrors';
import { useState } from 'react';
import Spinner from '../../../../../../../components/UI/Spinner/Spinner';
import { getComponentDependenciesByComponent } from '../../../../../_api';
import { ComponentDependency } from '../../../../../../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
import MaterialIcon from '@material/react-material-icon';
import styles from '../../../../../ApplicationMaintenance.module.scss';
const ComponentDependencyDisplay = ({
	component,
	app,
	currentUser,
	readOnly,
	requirementNumber,
}) => {
	const [apiErrors, setApiErrors] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [localDependencies, setLocalDependencies] = useState([
		...component.componentDependencies,
	]);

	const reloadComponentDependencies = () => {
		setIsLoading(true);
		getComponentDependenciesByComponent(component.id)
			.then(data => {
				let refreshedDependencies = data.map(
					dep => new ComponentDependency(dep)
				);
				setLocalDependencies(refreshedDependencies);
			})
			.then(x => setIsLoading(false));
	};

	const handleDelete = compDependency => {
		const request = new ComponentDependencyRequest(
			app,
			currentUser,
			compDependency
		);
		request.RequirementNumber = requirementNumber;
		setIsLoading(true);
		if (
			window.confirm(
				'Are you sure you want to delete this component dependency record? This can not be undone.'
			)
		) {
			DeactivateComponentDependency(request).then(response => {
				if (response.App.Errors.length > 0) {
					setApiErrors(response.App.Errors);
					setIsLoading(false);
				} else {
					setIsLoading(false);
					const remainingDependencies = localDependencies.filter(
						x => x.id !== compDependency.id
					);
					setLocalDependencies([...remainingDependencies]);
				}
			});
		} else {
			setIsLoading(false);
		}
	};

	const CompdependencyActions = ({ compDependency }) => {
		return (
			<div>
				<div className={styles.controlsContainer}>
					<ComponentDependencyForm
						component={component}
						app={app}
						currentUser={currentUser}
						reload={reloadComponentDependencies}
						readOnly={readOnly}
						requirementNumber={requirementNumber}
						componentDependency={compDependency}
					/>
				</div>
				<div className={styles.controlsContainer}>
					<Button
						startIcon={<MaterialIcon icon='delete' />}
						onClick={e => handleDelete(compDependency)}
						sx={{ marginBottom: 1 }}
					>
						Delete
					</Button>
				</div>
			</div>
		);
	};

	const headers = [
		{
			Value: 'Actions',
			props: { sort: null, onSortChange: null },
		},
		{ Value: 'ID', props: { sort: null, onSortChange: null } },
		{
			Value: 'Dependant Component',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'Conditional App Data',
			props: { sort: null, onSortChange: null },
		},
	];

	const rows = localDependencies.map(compdependency => {
		return {
			Cells: {
				Actions: {
					Value: (
						<CompdependencyActions
							compDependency={compdependency}
						/>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				ID: {
					Value: compdependency.id.toString(),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Dependant Component': {
					Value:
						compdependency.componentDependant.label +
						` (${compdependency.componentDependant.id})`,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Conditional App Data': {
					Value:
						compdependency.conditionalAppData?.fieldValue +
						' (' +
						compdependency.conditionalAppDataID.toString() +
						')',
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: compdependency.id.toString(),
		};
	});

	return (
		<Section label='Component Dependencies'>
			{isLoading ? (
				<Spinner />
			) : (
				<>
					<ApiErrors errors={apiErrors} />
					<DataTable rows={rows} headers={headers} />

					{/* new dependency form */}
					<ComponentDependencyForm
						component={component}
						app={app}
						currentUser={currentUser}
						reload={reloadComponentDependencies}
						readOnly={readOnly}
						requirementNumber={requirementNumber}
					/>
				</>
			)}
		</Section>
	);
};

export default ComponentDependencyDisplay;
